/* eslint-disable @typescript-eslint/no-explicit-any */
import * as echarts from "echarts";
import { CallbackDataParams } from "echarts/types/dist/shared";
import React from "react";
import { Stage } from "../layout";

interface ReportsV2Props {}

export const ReportsV2: React.FC<ReportsV2Props> = () => {
    return (
        <Stage>
            <div className="p-6">
                <dl className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 mb-8">
                    <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
                        <dt>
                            <div className="absolute rounded-md bg-blue-500 p-3">
                                <svg
                                    className="h-6 w-6 text-white"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
                                    />
                                </svg>
                            </div>
                            <p className="ml-16 truncate text-sm font-medium text-gray-500">
                                Total Referrals This Month
                            </p>
                        </dt>
                        <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
                            <p className="text-2xl font-semibold text-gray-900">47</p>
                            <p className="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                                <svg
                                    className="h-5 w-5 shrink-0 self-center text-green-500"
                                    viewBox="0 0 20 20"
                                    fill="currentColor">
                                    <path
                                        fillRule="evenodd"
                                        d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04L10.75 5.612V16.25A.75.75 0 0110 17z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <span className="sr-only">Increased by</span>
                                +12%
                            </p>
                            <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                                <div className="text-sm">
                                    <a
                                        href="#"
                                        className="font-medium text-blue-600 hover:text-blue-500">
                                        View details
                                        <span className="sr-only">
                                            {" "}
                                            Total Referrals stats
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </dd>
                    </div>

                    <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
                        <dt>
                            <div className="absolute rounded-md bg-green-500 p-3">
                                <svg
                                    className="h-6 w-6 text-white"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
                                    />
                                </svg>
                            </div>
                            <p className="ml-16 truncate text-sm font-medium text-gray-500">
                                Average Placement Rate
                            </p>
                        </dt>
                        <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
                            <p className="text-2xl font-semibold text-gray-900">34%</p>
                            <p className="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                                <svg
                                    className="h-5 w-5 shrink-0 self-center text-green-500"
                                    viewBox="0 0 20 20"
                                    fill="currentColor">
                                    <path
                                        fillRule="evenodd"
                                        d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04L10.75 5.612V16.25A.75.75 0 0110 17z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <span className="sr-only">Increased by</span>
                                +3%
                            </p>
                            <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                                <div className="text-sm">
                                    <a
                                        href="#"
                                        className="font-medium text-green-600 hover:text-green-500">
                                        View details
                                        <span className="sr-only">
                                            {" "}
                                            Placement Rate stats
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </dd>
                    </div>

                    <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
                        <dt>
                            <div className="absolute rounded-md bg-purple-500 p-3">
                                <svg
                                    className="h-6 w-6 text-white"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                </svg>
                            </div>
                            <p className="ml-16 truncate text-sm font-medium text-gray-500">
                                Avg. Days to Placement
                            </p>
                        </dt>
                        <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
                            <p className="text-2xl font-semibold text-gray-900">18</p>
                            <p className="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                                <svg
                                    className="h-5 w-5 shrink-0 self-center text-green-500"
                                    viewBox="0 0 20 20"
                                    fill="currentColor">
                                    <path
                                        fillRule="evenodd"
                                        d="M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <span className="sr-only">Decreased by</span>
                                -2 days
                            </p>
                            <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                                <div className="text-sm">
                                    <a
                                        href="#"
                                        className="font-medium text-purple-600 hover:text-purple-500">
                                        View details
                                        <span className="sr-only">
                                            {" "}
                                            Days to Placement stats
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </dd>
                    </div>
                </dl>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                    <div className="relative overflow-hidden rounded-lg bg-white shadow px-4 pb-12 pt-5 sm:px-6 sm:pt-6">
                        <div className="px-6 py-4 border-b border-gray-200">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        Referral Source Performance
                                    </h3>
                                    <p className="text-sm text-gray-600 mt-1">
                                        Track which sources generate the highest quality
                                        leads
                                    </p>
                                </div>
                                <div className="flex space-x-2">
                                    <button className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                                        Export
                                    </button>
                                    <button className="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-md hover:bg-blue-200">
                                        View Details
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="overflow-x-auto mt-4">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Source
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Leads
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Rate
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Revenue
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Avg Days
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    <tr className="hover:bg-gray-50 cursor-pointer">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">
                                                Hospital Social Workers
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                47 total leads
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                18 placements
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                16 days avg
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                                38%
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            $127,500
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                16 days
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 cursor-pointer">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">
                                                SNF Discharge Planners
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                32 total leads
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                11 placements
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                22 days avg
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                                34%
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            $98,250
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                22 days
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 cursor-pointer">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">
                                                Adult Children Direct
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                28 total leads
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                7 placements
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                19 days avg
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                                                25%
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            $52,500
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                19 days
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 cursor-pointer">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">
                                                Medical Professionals
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                19 total leads
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                3 placements
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                31 days avg
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                                16%
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            $22,500
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                31 days
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 cursor-pointer">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">
                                                Online Inquiries
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                14 total leads
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                1 placement
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                28 days avg
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                                7%
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            $7,500
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                28 days
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                            <div className="flex items-center justify-between text-sm">
                                <div className="text-gray-500">
                                    Showing 5 referral sources
                                </div>
                                <a
                                    href="#"
                                    className="font-medium text-blue-600 hover:text-blue-500">
                                    View Details
                                    <span className="sr-only">
                                        {" "}
                                        Referral Source Performance
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Current Bottlenecks */}
                    <div className="relative overflow-hidden rounded-lg bg-white shadow px-4 pb-12 pt-5 sm:px-6 sm:pt-6">
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">
                                    Current Bottlenecks
                                </h3>
                                <p className="text-sm text-gray-600 mt-1">
                                    See which stages have clients stuck and for how long
                                </p>
                            </div>
                            <div className="flex space-x-2">
                                <button className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                                    Export
                                </button>
                                <button className="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-md hover:bg-blue-200">
                                    View Details
                                </button>
                            </div>
                        </div>
                        <div className="mt-4">
                            <BottleneckChart />
                        </div>
                        <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                            <div className="text-sm">
                                <a
                                    href="#"
                                    className="font-medium text-blue-600 hover:text-blue-500">
                                    View Details
                                    <span className="sr-only"> Current Bottlenecks</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                    <div className="relative overflow-hidden rounded-lg bg-white shadow px-4 pb-12 pt-5 sm:px-6 sm:pt-6">
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">
                                    Pipeline Flow Over Time
                                </h3>
                                <p className="text-sm text-gray-600 mt-1">
                                    See how clients move between stages and where they
                                    flow fastest
                                </p>
                            </div>
                            <div className="flex space-x-2">
                                <button className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                                    Export
                                </button>
                                <button className="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-md hover:bg-blue-200">
                                    View Details
                                </button>
                            </div>
                        </div>
                        <div className="mt-4">
                            <FlowChart />
                        </div>
                        <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                            <div className="text-sm">
                                <a
                                    href="#"
                                    className="font-medium text-blue-600 hover:text-blue-500">
                                    View Details
                                    <span className="sr-only">
                                        {" "}
                                        Pipeline Flow Over Time
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <dl className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                        <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
                            <dt>
                                <div className="absolute rounded-md bg-green-500 p-3">
                                    <svg
                                        className="h-6 w-6 text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                    </svg>
                                </div>
                                <p className="ml-16 truncate text-sm font-medium text-gray-500">
                                    Pipeline Health Score
                                </p>
                            </dt>
                            <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
                                <p className="text-2xl font-semibold text-gray-900">
                                    82/100
                                </p>
                                <p className="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                                    Good
                                </p>
                                <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                                    <div className="text-sm">
                                        <a
                                            href="#"
                                            className="font-medium text-green-600 hover:text-green-500">
                                            View pipeline
                                            <span className="sr-only">
                                                {" "}
                                                Pipeline Health stats
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </dd>
                        </div>

                        <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
                            <dt>
                                <div className="absolute rounded-md bg-indigo-500 p-3">
                                    <svg
                                        className="h-6 w-6 text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                    </svg>
                                </div>
                                <p className="ml-16 truncate text-sm font-medium text-gray-500">
                                    Pipeline Value
                                </p>
                            </dt>
                            <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
                                <p className="text-2xl font-semibold text-gray-900">
                                    $245,000
                                </p>
                                <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                                    <div className="text-sm">
                                        <a
                                            href="#"
                                            className="font-medium text-indigo-600 hover:text-indigo-500">
                                            View breakdown
                                            <span className="sr-only">
                                                {" "}
                                                Pipeline Value stats
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </dd>
                        </div>

                        <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
                            <dt>
                                <div className="absolute rounded-md bg-orange-500 p-3">
                                    <svg
                                        className="h-6 w-6 text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                                        />
                                    </svg>
                                </div>
                                <p className="ml-16 truncate text-sm font-medium text-gray-500">
                                    Projected Moves
                                </p>
                            </dt>
                            <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
                                <p className="text-2xl font-semibold text-gray-900">14</p>
                                <p className="ml-2 flex items-baseline text-sm font-semibold text-gray-500">
                                    placements
                                </p>
                                <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                                    <div className="text-sm">
                                        <a
                                            href="#"
                                            className="font-medium text-orange-600 hover:text-orange-500">
                                            View forecast
                                            <span className="sr-only">
                                                {" "}
                                                Projected Moves stats
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </dd>
                        </div>

                        <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
                            <dt>
                                <div className="absolute rounded-md bg-cyan-500 p-3">
                                    <svg
                                        className="h-6 w-6 text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                    </svg>
                                </div>
                                <p className="ml-16 truncate text-sm font-medium text-gray-500">
                                    Avg. Time to Move
                                </p>
                            </dt>
                            <dd className="ml-16 flex items-baseline pb-6 sm:pb-7">
                                <p className="text-2xl font-semibold text-gray-900">21</p>
                                <p className="ml-2 flex items-baseline text-sm font-semibold text-gray-500">
                                    days
                                </p>
                                <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                                    <div className="text-sm">
                                        <a
                                            href="#"
                                            className="font-medium text-cyan-600 hover:text-cyan-500">
                                            View timeline
                                            <span className="sr-only">
                                                {" "}
                                                Avg. Time to Move stats
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </dd>
                        </div>
                    </dl>
                </div>

                {/* New Flow + Time Dashboard Section */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                    {/* Pipeline Flow Over Time */}

                    {/* Speed Performance */}
                    <div className="relative overflow-hidden rounded-lg bg-white shadow px-4 pb-12 pt-5 sm:px-6 sm:pt-6">
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">
                                    Speed Performance
                                </h3>
                                <p className="text-sm text-gray-600 mt-1">
                                    Track lead time trends and identify fast vs slow
                                    closers
                                </p>
                            </div>
                            <div className="flex space-x-2">
                                <button className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                                    Export
                                </button>
                                <button className="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-md hover:bg-blue-200">
                                    View Details
                                </button>
                            </div>
                        </div>
                        <div className="mt-4">
                            <CycleTimeChart />
                        </div>
                        <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                            <div className="text-sm">
                                <a
                                    href="#"
                                    className="font-medium text-blue-600 hover:text-blue-500">
                                    View Details
                                    <span className="sr-only"> Speed Performance</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Flow Trends */}
                    <div className="relative overflow-hidden rounded-lg bg-white shadow px-4 pb-12 pt-5 sm:px-6 sm:pt-6">
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">
                                    Flow Trends
                                </h3>
                                <p className="text-sm text-gray-600 mt-1">
                                    Monitor pipeline volume and identify trend changes
                                    over time
                                </p>
                            </div>
                            <div className="flex space-x-2">
                                <button className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
                                    Export
                                </button>
                                <button className="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-md hover:bg-blue-200">
                                    View Details
                                </button>
                            </div>
                        </div>
                        <div className="mt-4">
                            <TrendChart />
                        </div>
                        <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                            <div className="text-sm">
                                <a
                                    href="#"
                                    className="font-medium text-blue-600 hover:text-blue-500">
                                    View Details
                                    <span className="sr-only"> Flow Trends</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Stage>
    );
};

// Chart Components with Sample Data
const FlowChart: React.FC = () => {
    const chartRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (!chartRef.current) return () => {};
        const chart = echarts.init(chartRef.current);

        // Tailwind colors
        const DURATION_COLORS = {
            fast: "#10B981", // emerald-500
            medium: "#F59E0B", // amber-500
            slow: "#EF4444", // red-500
        };

        const STATUS_COLORS = {
            New: "#3B82F6", // blue-500
            Intake: "#8B5CF6", // violet-500
            Touring: "#10B981", // emerald-500
            Scheduled: "#F59E0B", // amber-500
            Moved: "#06B6D4", // cyan-500
            Invoice: "#EC4899", // pink-500
            Paid: "#F97316", // orange-500
            Declined: "#EF4444", // red-500
        };

        // Sample transition data
        const transitionData = [
            { from: "T0: New", to: "T1: New", count: 15, medianDays: 2.5 },
            { from: "T0: New", to: "T1: Intake", count: 8, medianDays: 2.0 },
            { from: "T1: New", to: "T2: New", count: 12, medianDays: 1.8 },
            { from: "T1: New", to: "T2: Intake", count: 6, medianDays: 3.2 },
            { from: "T1: Intake", to: "T2: Intake", count: 4, medianDays: 4.5 },
            { from: "T1: Intake", to: "T2: Touring", count: 8, medianDays: 5.1 },
            { from: "T2: New", to: "T3: New", count: 8, medianDays: 2.1 },
            { from: "T2: New", to: "T3: Intake", count: 4, medianDays: 6.8 },
            { from: "T2: Intake", to: "T3: Touring", count: 3, medianDays: 4.2 },
            { from: "T2: Touring", to: "T3: Touring", count: 5, medianDays: 12.5 },
            { from: "T2: Touring", to: "T3: Scheduled", count: 3, medianDays: 8.1 },
            { from: "T1: Touring", to: "T2: Scheduled", count: 2, medianDays: 6.5 },
            { from: "T2: Scheduled", to: "T3: Moved", count: 2, medianDays: 4.0 },
            { from: "T1: Scheduled", to: "T2: Moved", count: 1, medianDays: 3.5 },
            { from: "T2: Moved", to: "T3: Invoice", count: 2, medianDays: 2.8 },
            { from: "T3: Invoice", to: "Paid", count: 1, medianDays: 3.0 },
            { from: "T2: Invoice", to: "Paid", count: 1, medianDays: 4.2 },
            { from: "T2: Touring", to: "Declined", count: 2, medianDays: 45.0 },
            { from: "T3: Touring", to: "Declined", count: 1, medianDays: 38.5 },
        ];

        const getDurationColor = (days: number) => {
            if (days <= 3) return DURATION_COLORS.fast;
            if (days <= 7) return DURATION_COLORS.medium;
            return DURATION_COLORS.slow;
        };

        const timePeriods = [
            { key: "T0", label: "T0 (90d ago)" },
            { key: "T1", label: "T1 (60d ago)" },
            { key: "T2", label: "T2 (30d ago)" },
            { key: "T3", label: "T3 (Today)" },
        ];

        // Build nodes
        const nodes: Array<{ name: string; itemStyle: { color: string } }> = [];
        timePeriods.forEach(period => {
            Object.keys(STATUS_COLORS).forEach(status => {
                if (status !== "Paid" && status !== "Declined") {
                    nodes.push({
                        name: `${period.key}: ${status}`,
                        itemStyle: {
                            color: STATUS_COLORS[status as keyof typeof STATUS_COLORS],
                        },
                    });
                }
            });
        });
        nodes.push(
            { name: "Paid", itemStyle: { color: STATUS_COLORS.Paid } },
            { name: "Declined", itemStyle: { color: STATUS_COLORS.Declined } },
        );

        // Build links
        const links = transitionData.map(t => ({
            source: t.from,
            target: t.to,
            value: t.count,
            lineStyle: {
                color: getDurationColor(t.medianDays),
                opacity: 0.7,
            },
        }));

        const option = {
            tooltip: {
                trigger: "item",
                formatter: function (params: CallbackDataParams) {
                    if (params.dataType === "node") {
                        return `<strong>${params.name}</strong><br/>Count: ${
                            params.value || "N/A"
                        }`;
                    } else {
                        const data = params.data as { source: string; target: string };
                        return `<strong>${data.source}</strong> → <strong>${
                            data.target
                        }</strong><br/>
                               Flow: ${params.value} clients<br/>
                               Avg Duration: ${
                                   transitionData.find(
                                       t =>
                                           t.from === data.source && t.to === data.target,
                                   )?.medianDays || "N/A"
                               } days`;
                    }
                },
            },
            series: [
                {
                    type: "sankey",
                    data: nodes,
                    links: links,
                    emphasis: { focus: "adjacency" },
                    nodeWidth: 15,
                    nodeGap: 8,
                    layoutIterations: 32,
                    label: { fontSize: 10 },
                },
            ],
        };

        chart.setOption(option);

        const handleResize = () => chart.resize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            chart.dispose();
        };
    }, []);

    return <div ref={chartRef} style={{ height: "400px", width: "100%" }} />;
};

const CycleTimeChart: React.FC = () => {
    const chartRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (!chartRef.current) return () => {};
        const chart = echarts.init(chartRef.current);

        const STATUS_COLORS = { Paid: "#F97316", Declined: "#EF4444" };

        // Sample cycle time data
        const cycleTimeData = [
            { completionDate: "2024-08-05", leadTime: 7, amount: 4200, type: "Paid" },
            { completionDate: "2024-08-12", leadTime: 11, amount: 4500, type: "Paid" },
            { completionDate: "2024-09-02", leadTime: 18, amount: 5400, type: "Paid" },
            { completionDate: "2024-09-15", leadTime: 16, amount: 5200, type: "Paid" },
            { completionDate: "2024-10-05", leadTime: 31, amount: 8100, type: "Paid" },
            { completionDate: "2024-11-01", leadTime: 21, amount: 6000, type: "Paid" },
            { completionDate: "2024-11-15", leadTime: 12, amount: 5900, type: "Paid" },
            {
                completionDate: "2024-08-20",
                leadTime: 45,
                amount: 9200,
                type: "Declined",
            },
            {
                completionDate: "2024-09-18",
                leadTime: 52,
                amount: 6700,
                type: "Declined",
            },
            {
                completionDate: "2024-10-28",
                leadTime: 41,
                amount: 7200,
                type: "Declined",
            },
            {
                completionDate: "2024-11-10",
                leadTime: 56,
                amount: 7500,
                type: "Declined",
            },
        ];

        const paidTimes = cycleTimeData
            .filter(d => d.type === "Paid")
            .map(d => d.leadTime);
        const paidMedian = paidTimes.sort((a, b) => a - b)[
            Math.floor(paidTimes.length / 2)
        ];

        const option = {
            tooltip: {
                trigger: "item",
                formatter: function (params: CallbackDataParams) {
                    const data = params.data as any;
                    return `<strong>Date:</strong> ${data[0]}<br/>
                           <strong>Lead Time:</strong> ${data[1]} days<br/>
                           <strong>Amount:</strong> $${data[2].toLocaleString()}<br/>
                           <strong>Outcome:</strong> ${data[3]}`;
                },
            },
            xAxis: {
                type: "time",
                name: "Completion Date →",
                nameLocation: "middle",
                nameGap: 30,
            },
            yAxis: {
                type: "value",
                name: "Lead Time (Days)",
                nameLocation: "middle",
                nameGap: 40,
            },
            series: [
                {
                    name: "Paid Clients",
                    type: "scatter",
                    data: cycleTimeData
                        .filter(d => d.type === "Paid")
                        .map(d => [d.completionDate, d.leadTime, d.amount, d.type]),
                    itemStyle: {
                        color: STATUS_COLORS.Paid,
                        borderColor: "#fff",
                        borderWidth: 2,
                    },
                    symbolSize: function (data: [string, number, number, string]) {
                        return Math.max(8, Math.min(25, Math.sqrt(data[2]) / 60));
                    },
                },
                {
                    name: "Declined Clients",
                    type: "scatter",
                    data: cycleTimeData
                        .filter(d => d.type === "Declined")
                        .map(d => [d.completionDate, d.leadTime, d.amount, d.type]),
                    itemStyle: {
                        color: STATUS_COLORS.Declined,
                        borderColor: "#fff",
                        borderWidth: 2,
                    },
                    symbolSize: function (data: [string, number, number, string]) {
                        return Math.max(8, Math.min(25, Math.sqrt(data[2]) / 60));
                    },
                },
                {
                    name: `P50 Paid (${paidMedian}d)`,
                    type: "line",
                    data: [
                        ["2024-08-01", paidMedian],
                        ["2024-11-30", paidMedian],
                    ],
                    lineStyle: { color: STATUS_COLORS.Paid, type: "dashed" },
                    symbol: "none",
                },
            ],
        };

        chart.setOption(option);

        const handleResize = () => chart.resize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            chart.dispose();
        };
    }, []);

    return <div ref={chartRef} style={{ height: "400px", width: "100%" }} />;
};

const BottleneckChart: React.FC = () => {
    const chartRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (!chartRef.current) return () => {};
        const chart = echarts.init(chartRef.current);

        const DURATION_COLORS = {
            fast: "#10B981",
            medium: "#F59E0B",
            slow: "#EF4444",
        };

        // Sample aging data
        const agingData = [
            [0, 0, 3],
            [1, 0, 2],
            [2, 0, 1],
            [3, 0, 1], // New
            [0, 1, 2],
            [1, 1, 1],
            [2, 1, 3], // Intake
            [0, 2, 1],
            [2, 2, 2],
            [3, 2, 4], // Touring (bottleneck!)
            [1, 3, 1], // Scheduled
            [0, 4, 1], // Moved
        ];

        const option = {
            tooltip: {
                position: "top",
                formatter: function (params: any) {
                    const ageRanges = ["0-3 days", "4-7 days", "8-14 days", ">14 days"];
                    const stages = ["New", "Intake", "Touring", "Scheduled", "Moved"];
                    return `<strong>${stages[params.data[1]]}</strong><br/>
                           <strong>${ageRanges[params.data[0]]}</strong><br/>
                           <strong>Clients:</strong> ${params.data[2]}`;
                },
            },
            grid: { height: "60%", top: "10%" },
            xAxis: {
                type: "category",
                data: ["0-3d", "4-7d", "8-14d", ">14d"],
                splitArea: { show: true },
            },
            yAxis: {
                type: "category",
                data: ["New", "Intake", "Touring", "Scheduled", "Moved"],
                splitArea: { show: true },
            },
            visualMap: {
                min: 0,
                max: 4,
                calculable: true,
                orient: "horizontal",
                left: "center",
                bottom: "5%",
                inRange: {
                    color: [
                        "#ffffff",
                        DURATION_COLORS.fast,
                        DURATION_COLORS.medium,
                        DURATION_COLORS.slow,
                    ],
                },
            },
            series: [
                {
                    name: "Aging WIP",
                    type: "heatmap",
                    data: agingData,
                },
            ],
        };

        chart.setOption(option);

        const handleResize = () => chart.resize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            chart.dispose();
        };
    }, []);

    return <div ref={chartRef} style={{ height: "400px", width: "100%" }} />;
};

const TrendChart: React.FC = () => {
    const chartRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (!chartRef.current) return () => {};
        const chart = echarts.init(chartRef.current);

        const STATUS_COLORS = {
            New: "#3B82F6",
            Intake: "#8B5CF6",
            Touring: "#10B981",
            Scheduled: "#F59E0B",
            Moved: "#06B6D4",
            Invoice: "#EC4899",
        };

        const cfdDates = [
            "Aug 1",
            "Aug 15",
            "Sep 1",
            "Sep 15",
            "Oct 1",
            "Oct 15",
            "Nov 1",
            "Nov 15",
        ];
        const cfdData = {
            New: [8, 12, 15, 10, 8, 6, 9, 7],
            Intake: [3, 5, 8, 6, 4, 5, 3, 4],
            Touring: [2, 4, 6, 8, 12, 9, 7, 8],
            Scheduled: [1, 2, 3, 2, 4, 3, 2, 1],
            Moved: [0, 1, 1, 2, 1, 2, 1, 1],
            Invoice: [0, 0, 1, 1, 1, 2, 2, 1],
        };

        const option = {
            tooltip: { trigger: "axis" },
            legend: { bottom: 5 },
            xAxis: {
                type: "category",
                data: cfdDates,
                boundaryGap: false,
            },
            yAxis: {
                type: "value",
                name: "Count",
                nameLocation: "middle",
                nameGap: 40,
            },
            series: Object.entries(cfdData).map(([status, data]) => ({
                name: status,
                type: "line",
                stack: "Total",
                areaStyle: { opacity: 0.7 },
                data: data,
                itemStyle: {
                    color:
                        STATUS_COLORS[status as keyof typeof STATUS_COLORS] || "#6B7280",
                },
            })),
        };

        chart.setOption(option);

        const handleResize = () => chart.resize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            chart.dispose();
        };
    }, []);

    return <div ref={chartRef} style={{ height: "400px", width: "100%" }} />;
};
